/**
 * Where a non-chat app sends a member instead of rendering (ADR-20260930 D7).
 *
 * auth-service decides each member's home app from the current membership
 * and reports it on GET /session as home_app and home_url (the chat app for
 * a Guest, the admin console for every other role). An app other than the
 * chat app that loads for a member whose home is the chat app forwards there.
 * The client never derives the address; it follows home_url.
 *
 * Returns the address to forward to, or null to render as usual:
 * - the session names another home, or none (the server could not read the
 *   membership; the caller keeps its own behaviour);
 * - home_url is missing or not an http(s) address;
 * - home_url is this app's own origin, so a forward could only loop.
 *
 * Call it only from a non-chat app; the chat app is the home it forwards to.
 */
export function chatHomeForward(
  user: { homeApp?: string; homeUrl?: string } | null | undefined,
  currentOrigin: string = window.location.origin,
): string | null {
  if (user?.homeApp !== 'chat' || !user.homeUrl) return null
  let target: URL
  try {
    target = new URL(user.homeUrl)
  } catch {
    return null
  }
  if (target.protocol !== 'https:' && target.protocol !== 'http:') return null
  if (target.origin === currentOrigin) return null
  return target.toString()
}
